import { memo, useContext } from 'react';
import { useFieldArray } from 'react-hook-form';
import { XCircle } from 'react-feather';

import { getLanguage, useLanguage } from 'assets/languages';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import useIsMobile from 'hooks/useIsMobile/useIsMobile';
import { GetOptionTranslationMap } from 'constants/guidelineRules';
import TextInputField from 'components/textInput';
import PhotoModelField from '../../photoModelField';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';

const PhotoModelCloseUpField = () => {
  const language = useLanguage();
  const languageTexts = {
    ...language.component.guidelineCounter,
  };
  const { modal, guidelineRuleFormMethods } = useContext(CampaignFormContext);
  const isMobile = useIsMobile();

  const photoModelCloseup = useFieldArray({
    control: guidelineRuleFormMethods.control,
    name: GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_CLOSEUP,
    // react-hook-form id 값
    keyName: '_reactHookFormId',
  });

  const decrement = () => {
    if (photoModelCloseup.fields.length > 0) {
      photoModelCloseup.remove(photoModelCloseup.fields.length - 1);
    }
  };

  const increment = () => {
    photoModelCloseup.append({
      value: '',
    });
  };

  const openCloseUpExampleModel = () => {
    const closeUpExampleImgSrc = `https://nmodelin20.s3.ap-northeast-2.amazonaws.com/guide/PHOTO_MODEL_CLOSEUP_${getLanguage()}.png`;

    modal.showOverlays({
      content: () => {
        return (
          <div
            className={
              isMobile ? 'flex flex-col items-center bg-white py-12 px-5 overflow-scroll w-[100vw]' : 'relative'
            }
          >
            <div
              className="cursor-pointer absolute top-3 right-0 -translate-x-1/2"
              onClick={() => {
                modal.closeOverlays();
              }}
            >
              <XCircle stroke={isMobile ? 'black' : 'white'} />
            </div>

            <img className="cursor-pointer" width={300} height={300} src={closeUpExampleImgSrc} />
          </div>
        );
      },
    });
  };

  return (
    <li className="pb-[23px] border-b border-[#E8E8E8]">
      <PhotoModelField
        as="div"
        label={
          <div className="flex flex-row items-center">
            {GetOptionTranslationMap(GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_CLOSEUP)}
            <div>
              <img
                className="w-[14px] h-[14px] ml-1"
                src="/assets/icons/ic-help-circle-black.svg"
                onClick={openCloseUpExampleModel}
              />
            </div>
          </div>
        }
        count={photoModelCloseup.fields.length}
        decrement={decrement}
        increment={increment}
      />
      <ul className="flex flex-col gap-2">
        {photoModelCloseup.fields.map((field, index) => {
          return (
            <li key={`photo-model-closeup-value-${index}`}>
              <TextInputField
                bordered
                placeholder={languageTexts.fashion_index_placeholder}
                value={field.value || ''}
                onChangeText={(value) => {
                  photoModelCloseup.update(index, {
                    ...field,
                    value,
                  });
                }}
              />
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default memo(PhotoModelCloseUpField);
